import styled, { createGlobalStyle, css } from 'styled-components';

import { ContentContainer } from 'brand-guidelines/Layout-styled-components';
import { applyStylesForScreenSize } from 'brand-guidelines/utils/screenSizeUtils';
import { SCREEN_SIZES } from 'brand-guidelines/utils/screenSizeUtils';

// Override app/global-styles.js so we can use our own styles here
export const CheckoutGlobalStyle = createGlobalStyle`
  /* Higher specificity than the default app selector */
  div#app {
    background: none;
    > * {
      flex: unset;
    }
  }
`;

export const CheckoutPageContainer = styled(ContentContainer)`
  display: flex;
  flex-direction: column;
  padding: 24px 0;

  /* Prevent tooltips from overflowing the right edge */
  overflow-x: clip;

  ${applyStylesForScreenSize(
    [SCREEN_SIZES.PHONE],
    css`
      padding: 16px;
    `,
  )}
`;
